var customerModal = document.getElementById('customers-modal')
var partnersModal = document.getElementById('partners-modal')
var hotTopicModal = document.getElementById('hot-topic-modal')
var videoModals = document.getElementsByClassName('video-modal')
var teamModal = document.getElementById('team-modal')
var directorsModal = document.getElementById('directors-modal')
var selectedTeamCardsModals = document.querySelectorAll('.selected-team-cards-modal');

function getAdjacentCards(card, postType){
	let adjacentCards = {
		'nextID': null,
		'prevID': null
	}
	if( 'hot-topic' === postType ){
		if( card.parentNode.previousElementSibling && card.parentNode.previousElementSibling.querySelector('a').getAttribute('data-post-id') )
		 {
			 adjacentCards.prevID = card.parentNode.previousElementSibling.querySelector('a').getAttribute('data-post-id');
		 }
		if( card.parentNode.nextElementSibling && card.parentNode.nextElementSibling.querySelector('a').getAttribute('data-post-id') )
		  {
			  adjacentCards.nextID = card.parentNode.nextElementSibling.querySelector('a').getAttribute('data-post-id');
		  }
	} else if( 'team' === postType || 'directors' === postType || 'speakers' === postType ){
		let cardWrapper = card.closest('.card-outer-wrapper');
		if( cardWrapper.previousElementSibling ){
			adjacentCards.prevID = cardWrapper.previousElementSibling.getAttribute('data-post-id');
		}
		if( cardWrapper.nextElementSibling ){
			adjacentCards.nextID = cardWrapper.nextElementSibling.getAttribute('data-post-id');
		}
	} else {
	if( card.parentNode.parentNode.previousElementSibling && card.parentNode.parentNode.previousElementSibling.getAttribute('data-post-id') )
	 {
	 	adjacentCards.prevID = card.parentNode.parentNode.previousElementSibling.getAttribute('data-post-id');
	 }
	if( card.parentNode.parentNode.nextElementSibling && card.parentNode.parentNode.nextElementSibling.getAttribute('data-post-id') )
	  {
		  adjacentCards.nextID = card.parentNode.parentNode.nextElementSibling.getAttribute('data-post-id');
	  }
	}
	return adjacentCards;
}
function hookPrevNext(modalContent){
	let prevCardButton = modalContent.querySelector('#modal-previous-card');
	let nextCardButton = modalContent.querySelector('#modal-next-card');
	let objectType = modalContent.getAttribute('data-object-type');
	if( prevCardButton ){
	prevCardButton.addEventListener( 'click', event => {
			let prevCardID = prevCardButton.getAttribute('data-post-id');
			if(prevCardID != 0){
				let prevCard = document.getElementById( objectType + '-' + prevCardID).querySelector('a');
				loadCardIntoModal(prevCard);
			}
		});
	}
	if( nextCardButton ){
		nextCardButton.addEventListener( 'click', event => {
			let nextCardID = nextCardButton.getAttribute('data-post-id');
			if(nextCardID != 0){
				let nextCard = document.getElementById(objectType + '-' + nextCardID).querySelector('a');
				loadCardIntoModal(nextCard);
			}
		});
	}
}
function loadCardIntoModal(card){
	var id = card.getAttribute('data-post-id')
	var postType = card.getAttribute('data-post-type')
	var modalTarget = card.getAttribute('data-bs-target');
	console.log(card);
	const httpRequest = new XMLHttpRequest();
	const url = majesco_2022_ajax_load_more.ajaxurl;
	const adjacentCards = getAdjacentCards(card, postType);
	const data = {
		'modalType': 'customer',
		'postType': postType,
		'id': id,
		'nextID': adjacentCards.nextID,
		'prevID': adjacentCards.prevID,
	}
	httpRequest.onreadystatechange = () => {
		if (httpRequest.readyState === XMLHttpRequest.DONE) {
			if (httpRequest.status === 200) {
				let frag = document.createRange().createContextualFragment( httpRequest.responseText );
				let modal = document.querySelector(modalTarget);
				let modalContent = modal.querySelector('.modal-content');
				modalContent.replaceChildren( frag );
				//customerModal.handleUpdate();
				cdbootstrap.loadMore.init();
				hookPrevNext(modalContent);
			} else {
				console.log("There was a problem with the request.");
			}
		}
	}
	httpRequest.open( 'POST', url, true )
	httpRequest.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded' );
	httpRequest.send('action=majesco_2022_ajax_modals&data=' + JSON.stringify( data ));
}

if( customerModal != null ){
	customerModal.addEventListener('show.bs.modal', function (event) {
  		// Button that triggered the modal
  		var customer = event.relatedTarget
  		loadCardIntoModal(customer);
	})
}
if( partnersModal != null ){
	partnersModal.addEventListener('show.bs.modal', function (event) {
		  // Button that triggered the modal
		  var partner = event.relatedTarget
		  if( event.relatedTarget.classList.contains('majesco-2022-read-more-link')){
			  const article = event.relatedTarget.closest('.partner-excerpt').previousSibling.previousSibling
			  partner = article.querySelector('a.card-body')
		  }

		  loadCardIntoModal(partner);
	})
}
if( hotTopicModal != null ){
	hotTopicModal.addEventListener('show.bs.modal', function (event) {
		  // Button that triggered the modal
		  var hotTopic = event.relatedTarget
		  loadCardIntoModal(hotTopic);
	})
}
if( videoModals.length ){
	Array.from(videoModals).forEach( videoModal => {
		var embed = videoModal.getElementsByTagName('iframe')
		embed[0].setAttribute('data-src', embed[0].getAttribute('src'))
		videoModal.addEventListener( 'shown.bs.modal', event => {
			if( embed[0].getAttribute('src') == '' ) {
				embed[0].setAttribute('src', embed[0].getAttribute('data-src'))
			}
		} )
		videoModal.addEventListener( 'hide.bs.modal', event => {
			embed[0].setAttribute('src', '')
		} )
	} )
}
if( teamModal != null ){
	teamModal.addEventListener('show.bs.modal', function (event) {
		  // Button that triggered the modal
		  var team = event.relatedTarget
		  loadCardIntoModal(team);
	})
}
if( directorsModal != null ){
	directorsModal.addEventListener('show.bs.modal', function (event) {
		  // Button that triggered the modal
		  var directors = event.relatedTarget
		  loadCardIntoModal(directors);
	})
}
if( selectedTeamCardsModals != null ) {
	selectedTeamCardsModals.forEach( selectedTeamCardsModal => {
		selectedTeamCardsModal.addEventListener('show.bs.modal', function (event) {
			  // Button that triggered the modal
			  var directors = event.relatedTarget
			  loadCardIntoModal(directors);
		})
	})
}
document.addEventListener("DOMContentLoaded", function() {
  const relocateModals = document.querySelectorAll('.modal-relocate');
  relocateModals.forEach( relocateModal => {
		document.body.appendChild( relocateModal );
  });
});
